var monitoringApp = angular.module('monitoring', [
    'commons.app',
]);